import type {
  EnterpriseHomePageQuery_EnterpriseLearnerSummariesV1Resource_byUserIdAndThirdPartyOrgSlug_elements_enterprisePrograms_elements as EnterpriseProgram,
  EnterpriseHomePageQuery_EnterpriseLearnerSummariesV1Resource_byUserIdAndThirdPartyOrgSlug_elements_invitations_elements as ProgramInvitation,
} from 'bundles/program-home/components/enterprise-home/__generated__/EnterpriseHomePageQuery';

export function handleProgramRedirect(
  userId: number | null,
  enterprisePrograms: EnterpriseProgram[],
  programInvitations: ProgramInvitation[]
) {
  const isValidUser = userId && (enterprisePrograms.length > 0 || programInvitations.length > 0);

  // if only one program / invitation, redirect to that program or invitation
  if (isValidUser && enterprisePrograms.length + programInvitations.length === 1) {
    let programSlug: string | undefined;
    if (enterprisePrograms.length === 1) {
      programSlug = enterprisePrograms[0].metadata.slug;
    } else {
      programSlug = programInvitations[0].userRoster?.program?.metadata.slug;
    }

    if (programSlug) {
      return `/programs/${programSlug}`;
    }
  }

  return null;
}
